<template>
	<div>
		<v-layout row wrap align-center>
			<v-flex xs12>
				<p class="title-form">Datos de extranet</p>
			</v-flex>
			<v-flex xs12 text-xs-left mb-3>
				<v-layout row wrap align-center>
					<v-flex xs3>
						<label class="label-form">Nombre</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							v-model="model.name">
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 text-xs-left mb-3>
				<v-layout row wrap align-center>
					<v-flex xs3>
						<label class="label-form">Código</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							v-model="model.codeChannel">
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap align-center>
					<v-flex xs3 text-xs-left>
						<v-btn
							type="button"
							class="btn-save btn-save-form mt-3"
							:disabled="!model.name || !model.codeChannel"
							@click="saveChannel">
							Aceptar
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import mixin from '@/shared/mixins';

	function created() {
		if (this.channelId) {
			this.loadData();
		}
	}

	async function loadData() {
		const response = await this.$http.get(`${process.env.PMS_URL}/channels/${this.channelId}`);
		this.model = response.data.data;
	}

	async function saveChannel() {
		const method = this.channelId ? 'put' : 'post';
		const url = this.channelId ? `channels/${this.channelId}` : 'channels';
		const message = this.channelId ? 'actualizó' : 'creó';
		this.model.flagActive = this.model.flagActive ? this.model.flagActive : 1;
		delete this.model.companies;
		delete this.model.id;
		await this.$http[method](`${process.env.PMS_URL}/${url}`, this.model);
		this.showNotification(`La OTA se ${message} de manera correcta.`, 'success');
		this.$router.push({ name: 'channels-list' });
	}

	function data() {
		return {
			model: {
				codeChannel: '',
				name: '',
			},
		};
	}

	export default {
		name: 'channels-new',
		created,
		data,
		methods: {
			loadData,
			saveChannel,
		},
		mixins: mixin,
		props: ['channelId'],
	};
</script>

<style lang="scss" scoped>
	.divider-form {
		margin: 0 -20px;
		width: 100vw;
	}
</style>


// WEBPACK FOOTER //
// New.vue?783c596c